module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.submittingOrder) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('div', {
    staticClass: "loading-overlay-text"
  }, [_vm._v("\n                Submitting your order...\n                "), _c('loaders', {
    attrs: {
      "loader": "rolling"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('h1', {
    staticClass: "hero-title has-text-centered"
  }, [_vm._v("\n        Checkout\n    ")]), _vm._v(" "), (_vm.cartLoaded === true) ? _c('div', {
    staticClass: "review-boxes"
  }, [_c('div', {
    staticClass: "review-box"
  }, [_c('div', {
    staticClass: "review-box-title"
  }, [_vm._v("Your Order")]), _vm._v(" "), _c('div', {
    staticClass: "review-box-content"
  }, [(_vm.cartItems.length > 0) ? _c('div', [_c('div', {
    staticClass: "cart-listing"
  }, _vm._l((_vm.cartItems), function(item) {
    return _c('div', {
      staticClass: "cart-item"
    }, [_c('div', {
      staticClass: "cart-control",
      on: {
        "click": function($event) {
          return _vm.removeFromCart(item.id)
        }
      }
    }, [_c('icons', {
      attrs: {
        "icon": "close"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "cart-description"
    }, [_vm._v("\n                                " + _vm._s(item.name) + " -\n                                " + _vm._s(item.description) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "cart-price"
    }, [_vm._v("\n                                $" + _vm._s(item.price) + "\n                            ")])])
  }), 0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "cart-total-container"
  }, [_vm._v("\n                        Subtotal:\n                        "), _c('div', {
    staticClass: "cart-total"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("currency")(_vm.cartSubTotal)))])])]), _vm._v(" "), (_vm.cartTax > 0) ? _c('div', {
    staticClass: "cart-total-container"
  }, [_vm._v("\n                        Tax:\n                        "), _c('div', {
    staticClass: "cart-total"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("currency")(_vm.cartTax)))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cart-total-container"
  }, [_vm._v("\n                        Shipping:\n                        "), _c('div', {
    staticClass: "cart-total"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("currency")(_vm.shipTotal)))])])]), _vm._v(" "), _c('div', {
    staticClass: "cart-total-container"
  }, [_vm._v("\n                        Total:\n                        "), _c('div', {
    staticClass: "cart-total"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("currency")(_vm.cartTotal)))])])])]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "review-box"
  }, [_c('div', {
    staticClass: "review-box-title"
  }, [_vm._v("Shipping Information")]), _vm._v(" "), _c('div', {
    staticClass: "review-box-content container"
  }, [(_vm.shippingFilledOut && !_vm.editingShipping) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._v("\n                        " + _vm._s(_vm.shippingAddress.first_name) + "\n                        " + _vm._s(_vm.shippingAddress.last_name) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.shippingAddress.email) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.shippingAddress.phone) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.shippingAddress.address1) + "\n                        " + _vm._s(_vm.shippingAddress.address2) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.shippingAddress.city) + ",\n                        " + _vm._s(_vm.shippingAddress.state) + "\n                        " + _vm._s(_vm.shippingAddress.zip) + "\n                        "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button btn-sm",
    on: {
      "click": function($event) {
        _vm.editingShipping = true
      }
    }
  }, [_vm._v("Edit your information")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('shipping-options')], 1)]) : _c('div', [_c('shipping-form', {
    on: {
      "saved": function($event) {
        _vm.editingShipping = false
      }
    }
  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.shippingMethod !== false) ? _c('div', {
    staticClass: "review-box"
  }, [_c('div', {
    staticClass: "review-box-title"
  }, [_vm._v("Payment")]), _vm._v(" "), _c('div', {
    staticClass: "review-box-content"
  }, [(_vm.$store.state.payment.authorization === false) ? _c('div', [_c('div', {
    staticClass: "paypal-checkout"
  }, [_c('paypal', {
    attrs: {
      "currency": "USD",
      "dev": _vm.paypalDev,
      "amount": _vm.cartTotal,
      "create-payment": _vm.createPayment,
      "authorized-payment": _vm.authorizedPayment
    }
  })], 1)]) : _c('div', {
    staticClass: "is-5"
  }, [_c('strong', [_vm._v("\n                        You have authorized " + _vm._s(_vm._f("currency")(_vm.cartTotal)) + " to be transferred via PayPal.\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                    Click \"Finalize Order\" below to place your order and complete the transfer.\n                    "), _c('br'), _vm._v("\n                    You will receive an email confirmation of your order at the email address you supplied to\n                    PayPal.\n                ")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$store.state.payment.authorization !== false) ? _c('div', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button btn-important",
    on: {
      "click": function($event) {
        return _vm.executePayment()
      }
    }
  }, [_vm._v("Finalize Order")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c450977","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Review.vue
// module id = 216
// module chunks = 1